import PolyphileIntl from 'intl';
import 'intl/locale-data/jsonp/en.js';
import 'intl/locale-data/jsonp/ru.js';
import 'intl/locale-data/jsonp/uk.js';

if (!window.Intl) {
    const Intl = PolyphileIntl;
}

export default Intl;
